export const APP_NAME = "Stevos";
export const PERSIST_STORE_NAME = "user";
export const REDIRECT_URL_KEY = "redirectUrl";
